import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {catchError, Observable, throwError} from "rxjs";
import {environment} from 'src/environments/environment';
import {AuthService} from 'src/app/core/services/auth.service'

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Bloque para omitir solicitudes generadas (ej: imagenes, iconos, etc...)
    if (req.url.includes('assets')) {
      return next.handle(req);
    }

    const url = `${environment.apiUrl}${req.url}`.replace(/([^:]\/)\/+/g, '$1');
    const token = this.authService.getToken()
    if (token !== null) {
      req = this.addToken(req, token);
    }

    req = req.clone({url});
    return next.handle(req).pipe(
      catchError((err) => {
        if (err.status === 401 && !req.url.includes('auth/login')) {
          this.authService.logout();
        }
        return throwError(err);
      })
    )
  }

  private addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
    return req.clone({
      setHeaders: {
        'Authorization': `Bearer ${token}`
      }
    });
  }

}
